import { Skeleton, Box } from "@mui/material";

const LongCardSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: ".5vw",
        background: "#0D0D0D",
        width: "48vw",
        height: "10vw",
        padding: ".75vw",
        borderRadius: ".25vw",
      }}
    >
      <Box
        sx={{
          width: "24vw",
          height: "8.5vw",
          padding: ".75vw",
          borderRadius: ".35vw",
          border: ".05vw solid #C0C0C0",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: ".5vw" }}>
          {[...Array(4)].map((_, i) => (
            <Skeleton
              key={i}
              variant="text"
              animation="wave"
              height="1.4vw"
              width={"6vw"}
              sx={{ bgcolor: "grey.800" }}
            />
          ))}
        </Box>

        <Skeleton
          variant="rectangular"
          animation="wave"
          height="7vw"
          width="7vw"
          sx={{ borderRadius: ".25vw", bgcolor: "grey.800" }}
        />
      </Box>

      <Box sx={{ width: "100%", position: "relative", mt: ".5vw" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: ".5vw" }}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            height="1.5vw"
            width="20%"
            sx={{ borderRadius: ".25vw", bgcolor: "grey.800" }}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            height="1.5vw"
            width="100%"
            sx={{ borderRadius: ".25vw", bgcolor: "grey.800" }}
          />

          <Skeleton
            variant="rectangular"
            animation="wave"
            height="1.5vw"
            width="100%"
            sx={{ borderRadius: ".25vw", bgcolor: "grey.800" }}
          />

          <Box sx={{ display: "flex", gap: ".5vw", width: "100%" }}>
            <Skeleton
              variant="rectangular"
              animation="wave"
              height="1.4vw"
              width="100%"
              sx={{ borderRadius: ".25vw", bgcolor: "grey.800" }}
            />
          </Box>
        </Box>
        <Skeleton
          variant="circular"
          animation="wave"
          width="1vw"
          height="1vw"
          sx={{
            position: "absolute",
            top: "-.5vw",
            right: 0,
            bgcolor: "grey.800",
          }}
        />
      </Box>
    </Box>
  );
};

export default LongCardSkeleton;
